// extracted by mini-css-extract-plugin
export default {"newspaper":"Newspaper_newspaper__VT4vr","newspaper__wrapper":"Newspaper_newspaper__wrapper__tr0JN","newspaper__title":"Newspaper_newspaper__title__WkDRR"};